import React from 'react';
import { object, node } from 'prop-types';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';

import VisualTag from '../product-detail/VisualTag';
import VerifiedHighlight from '../product-detail/VerifiedHighlight';
import VisualHighlight from '../product-detail/VisualHighlight';

const Title = styled(ReactMarkdown)`
  color: #4a4a4a;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
`;

const Img = styled.img`
  width: inherit;
  max-width: 270px;
  margin: 16px auto;
  object-fit: contain;
`;


const Description = styled(ReactMarkdown)`
  * {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #999999;
    margin-top:8px;
  }

  strong {
    font-weight: bold;
  }

  a {
    color: #6E0AD6;
    font-weight: 700;
  }
`;

const transformToBold = text => text.replace(/"/g, '**');

const Paragraph = ({ children }) => <p style={{ display: 'inline' }}>{children}</p>;

const BenefitCarouselItem = ({ benefit }) => {
  const defaultRenderer = { paragraph: Paragraph };
  const isVehicleHistoryBenefit = benefit.id === 'vehicleHistory';
  const colorHighlightBadgeBoost = benefit.id === 'highlightBadgeBoost' ? '#F28000' : '#6e0ad6';
  const renderers = {
    ...defaultRenderer,
    strong: props => (isVehicleHistoryBenefit ? <VerifiedHighlight display="flex" {...props} /> : <VisualHighlight {...props} color={colorHighlightBadgeBoost} />),
    emphasis: props => <VisualTag {...props} />,
  };

  return (
    <div id={benefit.id}>
      <Title renderers={renderers}>
        {transformToBold(benefit.title)}
      </Title>
      <Img src={benefit.image} alt={benefit.title} />
      <Description>
        {benefit.text}
      </Description>
    </div>
  );
};

export default BenefitCarouselItem;

BenefitCarouselItem.propTypes = {
  benefit: object.isRequired,
};

Paragraph.propTypes = {
  children: node.isRequired,
};
